var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #83d4f7;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-6 {\n        fill: #ffd45b;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-8 {\n        fill: #dbdbdb;\n      }\n\n      .cls-9 {\n        fill: #37474f;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-14 {\n        fill: #455a64;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-23 {\n        fill: #a6a6a6;\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-27 {\n        fill: #f3f0e2;\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-30 {\n        fill: #c7c7c7;\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-34 {\n        fill: #e7e7e7;\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-39 {\n        opacity: .66;\n      }\n\n      .cls-39, .cls-40 {\n        fill: #718995;\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-45, .cls-46 {\n        opacity: .52;\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-50 {\n        opacity: .1;\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-53 {\n        fill: #ebebeb;\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-54, .cls-55 {\n        opacity: .1;\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-57 {\n        fill: none;\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-55 {\n        isolation: isolate;\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-74 {\n        fill: #263238;\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2.69,
    y: 0.97,
    width: 184.62,
    height: 107.84
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 92.21,
    cy: 99.77,
    fx: 92.21,
    fy: 99.77,
    r: 101.53,
    gradientTransform: "translate(4.13 191.81) rotate(-89.89) scale(1 .88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#51a1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7db9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b5d7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ddecf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f5fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.01,
    y1: 82.59,
    x2: 58.92,
    y2: 82.59,
    gradientTransform: "translate(183.49) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 26.19,
    y1: 75.82,
    x2: 59.75,
    y2: 75.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 26.19,
    y1: 70.53,
    x2: 59.75,
    y2: 70.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 73.17,
    y2: 73.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 26.19,
    y1: 63.89,
    x2: 59.75,
    y2: 63.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 26.19,
    y1: 100.8,
    x2: 59.75,
    y2: 100.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 42.97,
    y1: 103.65,
    x2: 42.97,
    y2: 51.2,
    gradientTransform: "translate(183.49) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9c4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c3d6d4",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9e5e4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 125.05,
    y1: 74.5,
    x2: 160.87,
    y2: 74.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 124.39,
    y1: 77.31,
    x2: 161.53,
    y2: 77.31,
    gradientTransform: "translate(183.49) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4d9c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4d9c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 71.81,
    y2: 71.81,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 125.05,
    y1: 74.56,
    x2: 160.87,
    y2: 74.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 54.5,
    y2: 54.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 47.17,
    y2: 47.17,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 100.77,
    y2: 100.77,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 128.78,
    y1: 62.34,
    x2: 135.4,
    y2: 62.34,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 129.32,
    y1: 61.12,
    x2: 134.86,
    y2: 61.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 131.53,
    y1: 65.2,
    x2: 134.86,
    y2: 65.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 130.38,
    y1: 64.63,
    x2: 134.86,
    y2: 64.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 129.32,
    y1: 59.53,
    x2: 132.77,
    y2: 59.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 129.32,
    y1: 60.67,
    x2: 134.86,
    y2: 60.67,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 139.65,
    y1: 62.34,
    x2: 146.27,
    y2: 62.34,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 140.19,
    y1: 61.12,
    x2: 145.73,
    y2: 61.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 142.4,
    y1: 65.2,
    x2: 145.73,
    y2: 65.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 141.25,
    y1: 64.63,
    x2: 145.73,
    y2: 64.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 140.19,
    y1: 59.53,
    x2: 143.64,
    y2: 59.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 140.19,
    y1: 60.67,
    x2: 145.73,
    y2: 60.67,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 150.52,
    y1: 62.34,
    x2: 157.14,
    y2: 62.34,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 151.05,
    y1: 61.12,
    x2: 156.6,
    y2: 61.12,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 153.26,
    y1: 65.2,
    x2: 156.6,
    y2: 65.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 152.11,
    y1: 64.63,
    x2: 156.6,
    y2: 64.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 151.05,
    y1: 59.53,
    x2: 154.51,
    y2: 59.53,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 151.05,
    y1: 60.67,
    x2: 156.6,
    y2: 60.67,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 128.78,
    y1: 50.88,
    x2: 135.4,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 130.73,
    y1: 50.88,
    x2: 134.86,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 129.32,
    y1: 50.88,
    x2: 132.77,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 139.65,
    y1: 50.88,
    x2: 146.27,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 141.6,
    y1: 50.88,
    x2: 145.73,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 140.19,
    y1: 50.88,
    x2: 143.64,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 150.52,
    y1: 50.88,
    x2: 157.14,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 152.47,
    y1: 50.88,
    x2: 156.6,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 151.05,
    y1: 50.88,
    x2: 154.51,
    y2: 50.88,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 150.43,
    y1: 91.62,
    x2: 158.7,
    y2: 91.62,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 154.41,
    y1: 97.63,
    x2: 157.47,
    y2: 97.63,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 151.66,
    y1: 86.59,
    x2: 157.47,
    y2: 86.59,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 151.66,
    y1: 88.48,
    x2: 157.47,
    y2: 88.48,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 151.66,
    y1: 94.87,
    x2: 157.47,
    y2: 94.87,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 151.66,
    y1: 84.02,
    x2: 153.27,
    y2: 84.02,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 151.66,
    y1: 92.9,
    x2: 157.47,
    y2: 92.9,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 127.21,
    y1: 89.76,
    x2: 147.76,
    y2: 89.76,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 150.29,
    y1: 86.9,
    x2: 150.56,
    y2: 86.9,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 158.56,
    y1: 86.9,
    x2: 158.82,
    y2: 86.9,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 141.59,
    y1: 94.2,
    x2: 147.25,
    y2: 94.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 127.73,
    y1: 88.19,
    x2: 139.15,
    y2: 88.19,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 127.73,
    y1: 89.05,
    x2: 140.86,
    y2: 89.05,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 137.16,
    y1: 91.99,
    x2: 147.25,
    y2: 91.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 145.39,
    y1: 96.1,
    x2: 147.25,
    y2: 96.1,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 127.73,
    y1: 85.62,
    x2: 134.01,
    y2: 85.62,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 142.96,
    y1: 104.69,
    x2: 142.96,
    y2: 29.08,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 55.54,
    y: 83.43,
    width: 27.37,
    height: 23.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 106.08,
    y: 83.43,
    width: 27.37,
    height: 23.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 55.54,
    y: 77.33,
    width: 77.91,
    height: 4.34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 2.69,
    y: -18.35,
    width: 184.62,
    height: 119.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m56.88,32.17h34.06s-1.69-2.09-3.56-2.33c0,0-3.63-10.15-9.71-10.22-5.65-.07-7.92,6.26-7.92,6.26,0,0-2.62-2.83-5.12-1.54s-3.92,5-3.92,5c0,0-2.83,1.4-3.84,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m164.84,49.68h-24.18s1.2-1.64,2.52-1.83c0,0,2.58-7.97,6.89-8.03,4.01-.06,5.62,4.91,5.62,4.91,0,0,1.86-2.22,3.63-1.21s2.78,3.93,2.78,3.93c0,0,2.01,1.1,2.73,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.46,32.53h40.95s-2.04-2.51-4.27-2.8c0,0-4.37-12.2-11.67-12.28-6.8-.09-9.52,7.52-9.52,7.52,0,0-3.15-3.4-6.16-1.85-3.01,1.55-4.71,6.02-4.71,6.02,0,0-3.4,1.68-4.62,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m66.09,29.6h-25.07s1.24-1.52,2.62-1.71c0,0,2.67-7.46,7.14-7.51,4.16-.05,5.82,4.59,5.82,4.59,0,0,1.92-2.09,3.76-1.13s2.88,3.67,2.88,3.67c0,0,2.07,1.04,2.84,2.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 42.39,
    y: 58.24,
    width: 14.46,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 42.39,
    y: 54.61,
    width: 12.4,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 43.98,
    y: 60.14,
    width: 11.29,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 64.05,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 68.06,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 72.08,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 76.09,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 80.1,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 84.11,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 88.13,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 92.14,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 96.15,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.98,
    y: 100.16,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 33.34,
    y: 58.24,
    width: 9.06,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 34.7,
    y: 54.61,
    width: 7.7,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 34.18,
    y: 60.14,
    width: 6.96,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 64.05,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 68.06,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 72.08,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 76.09,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 80.1,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 84.11,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 88.13,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 92.14,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 96.15,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.18,
    y: 100.16,
    width: 6.96,
    height: 0.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 160.08,
    y: 76.02,
    width: 11.18,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 78.2,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 81.48,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 84.76,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 88.05,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 91.34,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 94.62,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 167.52,
    y: 97.91,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 78.2,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 81.48,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 84.76,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 88.05,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 91.34,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 94.62,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 164.67,
    y: 97.91,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 78.2,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 81.48,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 84.76,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 88.05,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 91.34,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 94.62,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 161.83,
    y: 97.91,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 152.24,
    y: 76.02,
    width: 7.84,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 97.66,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 94.38,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 91.09,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 87.81,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 84.52,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 81.23,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 153.04,
    y: 77.95,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 97.66,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 94.38,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 91.09,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 87.81,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 84.52,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 81.23,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 155.36,
    y: 77.95,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 97.66,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 94.38,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 91.09,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 87.81,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 84.52,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 81.23,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 157.67,
    y: 77.95,
    width: 1.61,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 75.92,
    y: 71.56,
    width: 14.73,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 74.12,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 77.99,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 81.86,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 85.73,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 89.6,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 93.46,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 85.73,
    y: 97.34,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 74.12,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 77.99,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 81.86,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 85.73,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 89.6,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 93.46,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 81.97,
    y: 97.34,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 74.12,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 77.99,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 81.86,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 85.73,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 89.6,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 93.46,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.23,
    y: 97.34,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 75.92,
    y: 68.48,
    width: 9.81,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 75.92,
    y: 66.57,
    width: 6.22,
    height: 1.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 65.64,
    y: 71.56,
    width: 10.33,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 97.05,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 93.18,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 89.31,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 85.44,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 81.57,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 77.7,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 66.69,
    y: 73.83,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 97.05,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 93.18,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 89.31,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 85.44,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 81.57,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 77.7,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 69.74,
    y: 73.83,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 97.05,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 93.18,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 89.31,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 85.44,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 81.57,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 77.7,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 72.79,
    y: 73.83,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 67.2,
    y: 68.48,
    width: 8.77,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 71.22,
    y: 66.57,
    width: 4.75,
    height: 1.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 140.06,
    y: 36.79,
    width: 12.27,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 38.88,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 38.88,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 43.05,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 43.05,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 47.22,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 47.22,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 51.4,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 51.4,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 55.56,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 55.56,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 59.74,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 59.74,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 63.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 63.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 68.08,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 68.08,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 72.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 72.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 76.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 76.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 80.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 80.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 84.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 84.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 88.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 88.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 148.04,
    y: 93.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 93.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 88.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 84.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 80.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 76.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 72.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 68.07,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 63.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 59.73,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 55.56,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 51.39,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 47.22,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 43.05,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 141.97,
    y: 38.88,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 144.99,
    y: 93.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 130.38,
    y: 36.79,
    width: 9.68,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 93.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 93.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 88.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 88.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 84.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 84.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 80.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 80.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 76.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 76.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 72.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 72.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 68.07,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 68.07,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 63.91,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 63.91,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 59.73,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 59.73,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 55.56,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 55.56,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 51.39,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 51.39,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 47.22,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 47.22,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 43.05,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 43.05,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 131.38,
    y: 38.88,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 38.88,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 43.05,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 47.22,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 51.4,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 55.56,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 59.74,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 63.91,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 68.08,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 72.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 76.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 80.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 84.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 88.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 136.4,
    y: 93.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 133.9,
    y: 38.88,
    width: 1.97,
    height: 2.46
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 124.57,
    y: 63.89,
    width: 31.92,
    height: 37.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 128.2,
    y: 67.44,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 126.88,
    y: 66.19,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 129.51,
    y: 66.19,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 150.5,
    y: 66.19,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 151.81,
    y: 93.19,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 126.88,
    y: 94.44,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 132,
    y: 77.96,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 133.31,
    y: 79.21,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.74,
    y: 75.32,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 123.74,
    y: 75.32,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 123.74,
    y: 70.03,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 123.74,
    y: 70.03,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 124.57,
    y: 71.03,
    width: 31.92,
    height: 4.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 123.74,
    y: 63.39,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 123.74,
    y: 63.39,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 123.74,
    y: 100.29,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 123.74,
    y: 100.29,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 125.74,
    y: 77.2,
    width: 7.97,
    height: 4.51
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "125.74 77.2 125.74 79.34 128.11 81.71 130.76 81.71 126.25 77.2 125.74 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.8 77.2 133.32 81.71 133.71 81.71 133.71 81.54 129.36 77.2 128.8 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.77 77.2 133.71 80.14 133.71 79.04 131.87 77.2 130.77 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "125.74 80.1 125.74 81.2 126.25 81.71 127.34 81.71 125.74 80.1"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 125.74,
    y: 82.66,
    width: 7.97,
    height: 18.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 126.92,
    y: 83.88,
    width: 5.6,
    height: 9.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 83.88,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 84.17,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 84.46,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 84.75,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 85.04,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 85.34,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 85.63,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 85.92,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 86.21,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 86.5,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 86.79,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 87.08,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 87.38,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 87.67,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 87.96,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 88.25,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 88.54,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 88.83,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 89.13,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 89.42,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 89.71,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 90,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.92,
    y: 90.29,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.92 83.88 126.92 84.98 132.52 90.58 132.52 87.93 128.47 83.88 126.92 83.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.92 89.66 126.92 92.32 127.64 93.03 130.29 93.03 126.92 89.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.92 88.5 126.92 89.06 130.89 93.03 131.45 93.03 126.92 88.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.04 83.88 132.52 87.36 132.52 86.27 130.13 83.88 129.04 83.88"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 127.83,
    y: 94.07,
    width: 4.2,
    height: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 126.27,
    y: 93.47,
    width: 0.49,
    height: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m132.52,99.74c.02-.27.03-.54.04-.8s.02-.54.03-.81c.01-.54.02-1.07.03-1.61v-.09s-.09,0-.09,0h-1.26c-.42,0-.84,0-1.26,0s-.84.02-1.26.03c-.21,0-.42.01-.63.02s-.42.02-.63.03l.63.03c.21,0,.42.02.63.02.42.01.84.02,1.26.03s.84.01,1.26.01h1.26s-.09-.09-.09-.09c0,.54.01,1.07.03,1.61,0,.27.02.54.03.81s.02.54.04.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m126.92,96.52c-.02.27-.03.54-.04.81s-.02.54-.03.8c-.01.54-.02,1.07-.03,1.61v.09s.09,0,.09,0h1.28c.42,0,.85,0,1.28,0s.85-.02,1.28-.03l.64-.03c.21,0,.42-.02.64-.03l-.64-.03c-.21,0-.43-.02-.64-.02-.42-.01-.85-.02-1.28-.03s-.85-.01-1.28-.01h-1.28s.09.09.09.09c0-.54-.01-1.07-.03-1.61,0-.27-.01-.54-.03-.8s-.02-.55-.04-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m131.8,99.14c.03-.33.05-.67.06-1,0-.17.01-.33.02-.5s0-.33,0-.5v-.09s-.09,0-.09,0h-.94c-.31,0-.62,0-.94.01s-.62.01-.94.03-.62.03-.94.06c.31.03.62.05.94.06s.62.02.94.03.62,0,.94,0h.94s-.09-.09-.09-.09c0,.17,0,.33.01.5s0,.33.02.5c.03.33.04.66.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m127.65,97.13c-.03.33-.05.67-.06,1s-.02.67-.03,1v.09s.09,0,.09,0h.95c.32,0,.63,0,.95,0s.63-.02.95-.03.63-.03.95-.06c-.32-.03-.63-.05-.95-.06-.32-.01-.63-.02-.95-.03-.32,0-.63,0-.95-.01s-.63,0-.95,0l.09.09c0-.34,0-.67-.03-1-.01-.33-.03-.66-.06-.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 135.33,
    y: 76.69,
    width: 19.8,
    height: 17.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 135.82,
    y: 77.2,
    width: 18.81,
    height: 16.89
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "135.82 88.63 135.82 91.28 138.62 94.08 141.28 94.08 135.82 88.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "140.76 77.2 154.63 91.07 154.63 88.42 143.41 77.2 140.76 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "139.11 77.2 154.63 92.72 154.63 92.16 139.67 77.2 139.11 77.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "135.82 84.37 135.82 84.92 144.98 94.08 145.54 94.08 135.82 84.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "135.82 92.29 135.82 93.39 136.51 94.08 137.61 94.08 135.82 92.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "145.71 77.2 154.63 86.12 154.63 85.02 146.81 77.2 145.71 77.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m154.95,87.63c0,.1.08.19.19.19s.19-.08.19-.19c0-.1-.08-.19-.19-.19h0c-.1,0-.19.08-.19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.52,87.63c0,.1-.08.19-.19.19s-.19-.08-.19-.19c0-.1.08-.19.19-.19h0c.1,0,.19.08.19.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.03,98.93c.02-.27.03-.54.04-.81s.02-.54.03-.81c.01-.54.02-1.07.03-1.61v-.09s-.09,0-.09,0h-1.26c-.42,0-.84,0-1.26,0s-.84.02-1.26.03c-.21,0-.42.02-.63.02l-.63.03c.21.01.42.02.63.03s.42.02.63.02c.42.01.84.02,1.26.03s.84,0,1.26,0h1.26s-.09-.09-.09-.09c0,.54.01,1.07.03,1.61,0,.27.01.54.03.81s0,.55.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.43,95.7c-.02.27-.03.54-.04.81s-.02.54-.03.8c-.01.54-.02,1.07-.03,1.61v.09s.09,0,.09,0h1.28c.43,0,.85,0,1.28-.01s.85-.01,1.28-.03l.64-.03.64-.03c-.21-.01-.43-.02-.64-.03l-.64-.03c-.43-.01-.85-.02-1.28-.03s-.85-.01-1.28-.01h-1.28s.09.09.09.09c0-.54-.01-1.07-.03-1.61,0-.27-.02-.54-.03-.8s-.02-.53-.04-.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.3,98.32c.01-.33.03-.67.03-1v-1.05s-.05,0-.05,0h-.94s-.94,0-.94,0c-.31,0-.62,0-.93.01s-.63.02-.95.03c.31.01.62.02.95.03s.62.01.93.01h.94s.94,0,.94,0l-.04-.04v.5s0,.5,0,.5c.04.33.04.67.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.15,96.31c-.01.33-.02.67-.03,1s-.01.67-.01,1v.04s.04,0,.04,0h.95s.95,0,.95,0c.32,0,.63,0,.95-.01s.63-.01.95-.03c-.32-.01-.63-.02-.95-.03s-.63-.02-.95-.02h-.95s-.95,0-.95,0l.05.04c0-.33,0-.67-.01-1s-.02-.67-.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.3,98.32c.01-.33.02-.67.03-1v-1.05s-.04,0-.04,0h-.94s-.94,0-.94,0c-.31,0-.62,0-.94.01l-.94.03c.31.01.63.02.94.03s.62.01.94.01h.94s.94,0,.94,0l-.04-.04v.5s0,.5,0,.5c.03.33.05.67.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.14,96.31c0,.33-.02.67-.03,1s-.01.67-.01,1v.04s.04,0,.04,0h.95s.95,0,.95,0c.32,0,.63,0,.95-.01s.63-.01.95-.03c-.32-.01-.63-.02-.95-.03s-.63-.02-.95-.02h-.95s-.95,0-.95,0l.04.04c0-.33,0-.67-.01-1s0-.67-.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.03,98.93c.02-.27.03-.54.04-.81s.02-.54.03-.81c.01-.54.02-1.07.03-1.61v-.09s-.09,0-.09,0h-1.26c-.42,0-.84,0-1.26,0s-.84.02-1.26.03c-.21,0-.42.02-.63.02l-.63.03c.21.01.42.02.63.03s.42.02.63.02c.42.01.84.02,1.26.03s.84,0,1.26,0h1.26s-.09-.09-.09-.09c0,.54.01,1.07.03,1.61,0,.27.02.54.03.81s.02.55.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.43,95.7c-.02.27-.03.54-.04.81s-.02.54-.03.8c-.01.54-.02,1.07-.03,1.61v.09s.09,0,.09,0h1.28c.42,0,.85,0,1.28-.01s.85-.01,1.28-.03l.64-.03c.21,0,.42-.02.64-.03-.21-.01-.42-.02-.64-.03l-.64-.03c-.42-.01-.85-.02-1.28-.03s-.85-.01-1.28-.01h-1.28s.09.09.09.09c0-.54-.01-1.07-.03-1.61,0-.27-.01-.54-.03-.8s-.04-.53-.04-.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.3,98.32c.01-.33.02-.67.03-1v-1.05s-.03,0-.03,0h-.94s-.94,0-.94,0c-.31,0-.62,0-.95.01s-.62.02-.94.03c.31.01.62.02.94.03s.62.01.95.01h.92s.94.01.94.01l-.05-.04v.5s0,.5,0,.5c.03.32.04.65.06.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.15,96.31c-.01.33-.02.67-.03,1s-.01.67-.01,1v.04s.05,0,.05,0h.95s.95,0,.95,0c.32,0,.63,0,.95-.01s.63-.01.95-.03c-.32-.01-.63-.02-.95-.03s-.63-.02-.95-.02h-.95s-.95,0-.95,0l.04.04c0-.33,0-.67-.01-1s-.02-.67-.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.01,98.93c.02-.27.03-.54.04-.81s.02-.54.03-.81c.01-.54.02-1.07.03-1.61v-.09s-.09,0-.09,0h-1.26c-.42,0-.84,0-1.26,0s-.84.02-1.26.03c-.21,0-.42.02-.63.02l-.63.03c.21.01.42.02.63.03s.42.02.63.02c.42.01.84.02,1.26.03s.84,0,1.26,0h1.26s-.09-.09-.09-.09c0,.54.01,1.07.03,1.61,0,.27.01.54.03.81s.04.55.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.42,95.7c-.02.27-.03.54-.04.81s-.02.54-.03.8c-.01.54-.02,1.07-.03,1.61v.09s.09,0,.09,0h1.28c.43,0,.85,0,1.28-.01s.85-.01,1.28-.03l.64-.03.64-.03c-.21-.01-.43-.02-.64-.03l-.64-.03c-.43-.01-.85-.02-1.28-.03s-.85-.01-1.28-.01h-1.28s.09.09.09.09c0-.54-.01-1.07-.03-1.61,0-.27-.02-.54-.03-.8s-.02-.53-.04-.8Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "157.3 64.39 156.48 64.39 156.48 70.03 157.3 70.03 157.3 71.03 156.48 71.03 156.48 71.03 156.48 75.32 157.3 75.32 157.3 76.32 156.48 76.32 156.48 100.29 157.3 100.29 157.3 101.3 156.48 101.3 133.71 101.3 125.74 101.3 124.57 101.3 123.74 101.3 123.74 100.29 124.57 100.29 124.57 76.32 123.74 76.32 123.74 75.32 124.57 75.32 124.57 71.03 124.57 71.03 123.74 71.03 123.74 70.03 124.57 70.03 124.57 64.39 123.74 64.39 123.74 63.39 157.3 63.39 157.3 64.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 22.62,
    y: 47.69,
    width: 35.82,
    height: 53.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 25.93,
    y: 69.6,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 24.57,
    y: 68.29,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 27.3,
    y: 68.29,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 32.34,
    y: 55.78,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 30.97,
    y: 57.08,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 54.01,
    y: 68.29,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 54.01,
    y: 94.18,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 55.37,
    y: 92.88,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 24.57,
    y: 94.18,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 32.34,
    y: 78.9,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 33.7,
    y: 80.2,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 52.64,
    y: 49.84,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 54,
    y: 51.15,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 43.56,
    y: 51.15,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 21.96,
    y: 76.79,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 21.96,
    y: 71.29,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "58.44 76.79 58.44 72.34 22.62 72.34 22.62 76.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 21.96,
    y: 53.98,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 21.96,
    y: 46.65,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 21.96,
    y: 100.25,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 21.96,
    y: 100.25,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 48.09,
    y: 57.27,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 48.63,
    y: 57.8,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "48.63 57.8 48.63 58.9 54.17 64.44 54.17 61.81 50.16 57.8 48.63 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.63 63.53 48.63 66.16 49.33 66.87 51.96 66.87 48.63 63.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "48.63 62.38 48.63 62.94 52.56 66.87 53.11 66.87 48.63 62.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "50.72 57.8 54.17 61.26 54.17 60.17 51.81 57.8 50.72 57.8"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 48.63,
    y: 60.4,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 37.22,
    y: 57.27,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 37.76,
    y: 57.8,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "37.76 57.8 37.76 58.9 43.3 64.44 43.3 61.81 39.3 57.8 37.76 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "37.76 63.53 37.76 66.16 38.47 66.87 41.09 66.87 37.76 63.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "37.76 62.38 37.76 62.94 41.69 66.87 42.25 66.87 37.76 62.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "39.85 57.8 43.3 61.26 43.3 60.17 40.94 57.8 39.85 57.8"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 37.76,
    y: 60.4,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 26.35,
    y: 57.27,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 26.89,
    y: 57.8,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "26.89 57.8 26.89 58.9 32.44 64.44 32.44 61.81 28.43 57.8 26.89 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "26.89 63.53 26.89 66.16 27.6 66.87 30.23 66.87 26.89 63.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "26.89 62.38 26.89 62.94 30.83 66.87 31.38 66.87 26.89 62.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "28.98 57.8 32.44 61.26 32.44 60.17 30.07 57.8 28.98 57.8"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 26.89,
    y: 60.4,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 48.09,
    y: 49.04,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 48.63,
    y: 49.58,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "48.63 49.58 48.63 50.68 50.13 52.18 52.76 52.18 50.16 49.58 48.63 49.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "50.72 49.58 53.32 52.18 54.17 52.18 54.17 51.95 51.81 49.58 50.72 49.58"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 37.22,
    y: 49.04,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 37.76,
    y: 49.58,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "37.76 49.58 37.76 50.68 39.26 52.18 41.89 52.18 39.29 49.58 37.76 49.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "39.85 49.58 42.45 52.18 43.3 52.18 43.3 51.95 40.94 49.58 39.85 49.58"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 26.35,
    y: 49.04,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 26.89,
    y: 49.58,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "26.89 49.58 26.89 50.68 28.4 52.18 31.02 52.18 28.43 49.58 26.89 49.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "28.98 49.58 31.58 52.18 32.44 52.18 32.44 51.95 30.07 49.58 28.98 49.58"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 24.79,
    y: 81.95,
    width: 8.28,
    height: 19.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 26.02,
    y: 83.21,
    width: 5.81,
    height: 15.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "26.02 96.1 26.02 98.85 26.33 99.16 29.08 99.16 26.02 96.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "26.02 83.21 26.02 84.15 31.83 89.96 31.83 87.21 27.83 83.21 26.02 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "26.02 85.29 26.02 85.87 31.83 91.68 31.83 91.1 26.02 85.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "26.02 91.67 26.02 92.25 31.83 98.07 31.83 97.49 26.02 91.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "30.22 83.21 31.83 84.83 31.83 83.69 31.36 83.21 30.22 83.21"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 25.14,
    y: 93.17,
    width: 0.51,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 26.02,
    y: 92.64,
    width: 5.81,
    height: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 35.73,
    y: 81.95,
    width: 20.55,
    height: 15.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 36.24,
    y: 82.48,
    width: 19.53,
    height: 14.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.93,86.9c0,.07.06.13.14.13.07,0,.13-.06.13-.13,0-.07-.06-.13-.13-.14-.07,0-.14.06-.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24.94,86.9c0,.07-.06.13-.14.13-.07,0-.13-.06-.13-.13,0-.07.06-.13.13-.14.07,0,.14.06.14.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 36.24,
    y: 82.48,
    width: 19.53,
    height: 14.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "36.24 91.37 36.24 94.12 39.15 97.03 41.9 97.03 36.24 91.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "44.34 82.48 55.77 93.91 55.77 91.15 47.09 82.48 44.34 82.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "42.63 82.48 55.77 95.62 55.77 95.04 43.21 82.48 42.63 82.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "36.24 86.94 36.24 87.52 45.75 97.03 46.33 97.03 36.24 86.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "36.24 95.17 36.24 96.31 36.96 97.03 38.1 97.03 36.24 95.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "49.48 82.48 55.77 88.77 55.77 87.63 50.62 82.48 49.48 82.48"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "59.1 46.65 21.96 46.65 21.96 47.69 22.62 47.69 22.62 53.98 21.96 53.98 21.96 55.02 22.62 55.02 22.62 71.29 21.96 71.29 21.96 72.34 22.62 72.34 22.62 72.34 22.62 76.79 21.96 76.79 21.96 77.83 22.62 77.83 22.62 100.25 21.96 100.25 21.96 101.3 22.62 101.3 22.62 101.3 58.44 101.3 58.44 101.3 59.1 101.3 59.1 100.25 58.44 100.25 58.44 77.83 59.1 77.83 59.1 76.79 58.44 76.79 58.44 72.34 58.44 72.34 59.1 72.34 59.1 71.29 58.44 71.29 58.44 55.02 59.1 55.02 59.1 53.98 58.44 53.98 58.44 47.69 59.1 47.69 59.1 46.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m15.99,79.09s-6.05,13.44,3.83,13.45c9.88.01,3.49-13.9,3.49-13.9,0,0,2.29-1-.36-8.51s-3.83-7.51-4.93-7.51c-1.39,0-2.7,3.25-1.75,8.23,0,0-3.48,6.22-.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "20.68 101.46 19.75 81.2 18.78 101.46 20.68 101.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "20.13 89.7 16.54 85.5 19.35 90.25 20.13 89.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m166.5,79.09s-6.05,13.44,3.83,13.45c9.88.01,3.49-13.9,3.49-13.9,0,0,2.29-1-.36-8.51-2.64-7.5-3.83-7.51-4.93-7.51-1.39,0-2.7,3.25-1.75,8.23,0,0-3.48,6.22-.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "171.19 101.46 170.26 81.2 169.29 101.46 171.19 101.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "170.64 89.7 167.05 85.5 169.86 90.25 170.64 89.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m143.71,78.36s3.11-1.23,5.58,3.07c2.53,4.41-.65,7.31-3.17,5.58,0,0-1.98,4.15-5.93,3.15s-4.59-4.15-4.59-4.15c0,0-3.51.24-3.6-2.37-.09-2.62,2.47-4.94,2.47-4.94,0,0,.16-6.52,4.4-6.47,4.25.05,4.83,6.13,4.83,6.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "140.79 101.46 139.92 82.06 139.01 101.46 140.79 101.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "140.19 89.33 142.91 83.91 139.65 88.49 140.19 89.33"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.2,
    y: 47.6,
    width: 88.59,
    height: 22.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.2,
    y: 40.82,
    width: 88.59,
    height: 6.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.2,
    y: 69.8,
    width: 88.59,
    height: 38.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 97.09,
    y: 53.12,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 136.66,
    y: 53.12,
    width: 2.13,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 99.47,
    y: 50.85,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 134.23,
    y: 50.85,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 94.72,
    y: 50.85,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 110.64,
    y: 65.19,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 81.56,
    y: 66.68,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 51.92,
    y: 66.68,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 50.2,
    y: 64.43,
    width: 3.46,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 126.9,
    y: 65.19,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 108.27,
    y: 62.92,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 69.52,
    y: 50.85,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 48.72,
    y: 69.8,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 48.72,
    y: 45.79,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 48.72,
    y: 106.66,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 48.72,
    y: 69.8,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 48.72,
    y: 45.79,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 48.72,
    y: 39.65,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 48.72,
    y: 39.65,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 48.72,
    y: 106.66,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 48.72,
    y: 106.66,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 82.91,
    y: 81.66,
    width: 11.53,
    height: 26.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 84.63,
    y: 83.42,
    width: 8.1,
    height: 18.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.73 83.42 92.73 85.02 84.63 93.12 84.63 89.28 90.49 83.42 92.73 83.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.73 91.79 92.73 95.63 86.77 101.6 84.63 101.6 84.63 99.9 92.73 91.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.73 90.11 92.73 90.92 84.63 99.03 84.63 98.22 92.73 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.67 83.42 84.63 88.46 84.63 86.88 88.08 83.42 89.67 83.42"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.24,
    y: 95.65,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 84.63,
    y: 96.52,
    width: 8.1,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 94.55,
    y: 81.66,
    width: 11.53,
    height: 26.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 96.26,
    y: 83.42,
    width: 8.1,
    height: 18.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.36 83.42 104.36 85.02 96.26 93.12 96.26 89.28 102.12 83.42 104.36 83.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.36 91.79 104.36 95.63 98.41 101.6 96.26 101.6 96.26 99.9 104.36 91.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.36 90.11 104.36 90.92 96.26 99.03 96.26 98.22 104.36 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.31 83.42 96.26 88.46 96.26 86.88 99.72 83.42 101.31 83.42"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 95.19,
    y: 95.65,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 93.24,
    y: 95.65,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 95.19,
    y: 95.65,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 96.26,
    y: 96.52,
    width: 8.1,
    height: 1.29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 55.54,
    y: 83.43,
    width: 27.37,
    height: 23.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.82,
    y: 75.61,
    width: 1.72,
    height: 31.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.96,
    y: 66.52,
    width: 1.72,
    height: 31.99,
    transform: "translate(-12.7 152.34) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 73.33,
    y: 56.11,
    width: 1.72,
    height: 40.72,
    transform: "translate(-2.28 150.66) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 133.55,
    y: 75.61,
    width: 1.72,
    height: 31.04,
    transform: "translate(268.81 182.27) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 118.41,
    y: 66.52,
    width: 1.72,
    height: 31.99,
    transform: "translate(36.75 201.79) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 114.04,
    y: 56.11,
    width: 1.72,
    height: 40.72,
    transform: "translate(38.43 191.37) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "36.26 115.09 30.49 115.09 71.54 74.05 77.31 74.05 36.26 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "45.52 115.09 42.67 115.09 83.71 74.05 86.56 74.05 45.52 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "72.66 115.09 69.81 115.09 110.85 74.05 113.7 74.05 72.66 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "65.48 115.09 52.27 115.09 93.32 74.05 106.52 74.05 65.48 115.09"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 106.14,
    y: 83.38,
    width: 27.48,
    height: 23.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 55.54,
    y: 77.33,
    width: 78.01,
    height: 4.34
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.8 115.09 81.04 115.09 122.08 74.05 127.85 74.05 86.8 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "96.06 115.09 93.21 115.09 134.25 74.05 137.1 74.05 96.06 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "123.2 115.09 120.35 115.09 161.39 74.05 164.24 74.05 123.2 115.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "116.02 115.09 102.81 115.09 143.86 74.05 157.06 74.05 116.02 115.09"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.31 100.02 45.55 100.02 86.59 58.97 92.36 58.97 51.31 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "60.57 100.02 57.72 100.02 98.77 58.97 101.61 58.97 60.57 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "87.71 100.02 84.86 100.02 125.9 58.97 128.75 58.97 87.71 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "80.53 100.02 67.33 100.02 108.37 58.97 121.57 58.97 80.53 100.02"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "101.89 100.02 96.12 100.02 137.16 58.97 142.93 58.97 101.89 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "111.15 100.02 108.3 100.02 149.34 58.97 152.19 58.97 111.15 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "138.29 100.02 135.44 100.02 176.48 58.97 179.33 58.97 138.29 100.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "131.1 100.02 117.9 100.02 158.94 58.97 172.14 58.97 131.1 100.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m77.96,56.92h1.34v1.49h-1.34v1.48c0,.46.16.66.51.66h.83v1.47s-1.72,0-1.72,0c-1.05,0-1.55-.59-1.55-1.62v-1.99h-.85v-1.49h.46c.28,0,.33-.15.38-.43l.13-.74h1.79v1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m85.32,56.92v5.1h-1.92v-.67c-.26.47-.77.76-1.46.76-1.32,0-2.28-.98-2.28-2.63s.96-2.63,2.28-2.63c.67,0,1.18.28,1.46.75v-.67h1.92Zm-2.84,3.7c.5,0,.89-.41.89-1.15,0-.74-.38-1.15-.89-1.15s-.9.38-.9,1.15.37,1.15.9,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m89.31,58.47c-.12-.13-.3-.2-.54-.2-.47,0-.81.37-.81.86v2.89h-1.92v-5.1h1.92v.64c.24-.45.77-.72,1.41-.72s1.13.16,1.47.45c.4.35.59.9.59,1.62v3.12h-1.92v-2.92c0-.29-.07-.5-.2-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m97.63,55.27v6.75h-1.92v-.67c-.28.49-.79.76-1.46.76-1.32,0-2.28-.98-2.28-2.63s.96-2.63,2.28-2.63c.67,0,1.16.26,1.46.75v-2.32h1.92Zm-2.84,5.35c.5,0,.89-.41.89-1.15,0-.74-.38-1.15-.89-1.15s-.9.38-.9,1.15.37,1.15.9,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m103.88,56.92v5.1h-1.92v-.67c-.26.47-.77.76-1.46.76-1.32,0-2.28-.98-2.28-2.63s.96-2.63,2.28-2.63c.67,0,1.18.28,1.46.75v-.67h1.92Zm-2.84,3.7c.5,0,.89-.41.89-1.15,0-.74-.38-1.15-.89-1.15s-.9.38-.9,1.15.37,1.15.9,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.53,59.32v2.7h-1.92v-5.1h1.92v.58c.28-.45.78-.67,1.39-.67v1.46c-.96-.07-1.39.4-1.39,1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.99,56.92h1.35v1.49h-1.35v1.48c0,.46.16.66.51.66h.84v1.47s-1.72,0-1.72,0c-1.05,0-1.55-.59-1.55-1.62v-1.99h-.85v-1.49h.46c.28,0,.33-.15.39-.43l.12-.74h1.79v1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m115.43,57.98c-.41,0-.65.15-.63.37.02.26.37.41.99.51,1.61.26,2.26.6,2.25,1.55,0,1.11-1.1,1.7-2.67,1.69-1.57,0-2.6-.51-2.56-1.72h1.86c-.04.32.28.54.74.54s.71-.18.66-.44c-.04-.29-.71-.39-1.6-.59-1.04-.23-1.63-.7-1.63-1.56,0-1.02,1.01-1.52,2.54-1.5,1.41,0,2.54.52,2.5,1.64h-1.86c.01-.32-.23-.5-.61-.5Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.14,
    cy: 58.36,
    r: 8.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m67.22,53.5l4.77,5.32c-.04.72-.28,3.42-2.48,5.69-2.53,2.62-5.77,2.7-6.38,2.71-.85-1.2-1.7-2.39-2.54-3.59-.11-.35-1.2-3.97,1.17-7.1,1.99-2.63,4.96-2.98,5.46-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m67.57,56.37s0-.05.01-.08c0-.02,0-.04,0-.07,0-.05.01-.1.01-.14,0-.01,0-.03,0-.04,0-.04,0-.07,0-.11,0-.02,0-.03,0-.05,0-.04,0-.07,0-.11,0-.01,0-.03,0-.04,0-.1,0-.2,0-.3,0,0,0-.01,0-.02,0-.04,0-.09,0-.13,0,0,0,0,0-.01,0-.13,0-.26,0-.38,0-1.1-.65-2.23-2.02-2.23h0c-.24-.04-.51-.01-.8.04-.76.04-1.56.53-1.66.55-.1-.02-.9-.51-1.66-.55-.3-.05-.56-.07-.8-.04h0c-1.37,0-2.02,1.13-2.02,2.23,0,.12,0,.25,0,.38,0,0,0,0,0,.01,0,.04,0,.09,0,.13,0,0,0,.01,0,.02,0,.1,0,.2,0,.3,0,.01,0,.03,0,.04,0,.04,0,.07,0,.11,0,.02,0,.03,0,.05,0,.04,0,.07,0,.11,0,.01,0,.03,0,.04,0,.05,0,.1.01.14,0,.02,0,.04,0,.07,0,.03,0,.05.01.08,0,.03,0,.06.01.08,0,.02,0,.04,0,.06,0,.02,0,.04,0,.06.31,3.24,1.38,7.52,2.53,7.52h0s0,0,0,0c0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,.01,0,.03,0,.04-.02,0,0,0,0,0,0,.01,0,.02-.01.03-.02,0,0,0,0,.01,0,0,0,.02-.01.02-.02,0,0,0,0,.01-.01,0,0,.02-.01.02-.02,0,0,0,0,.01-.01,0-.01.02-.02.03-.03,0,0,0,0,0,0,.01-.01.02-.03.03-.04,0,0,0-.01,0-.02,0-.01.01-.02.02-.03,0,0,0,0,0,0,0,0,0,0,0,0,.02-.04.04-.08.06-.13.09-.23.13-.49.11-.74,0-.12-.01-.24-.01-.37,0-1.39.59-2.52,1.32-2.57.73.04,1.32,1.18,1.32,2.57,0,.13,0,.25-.01.37-.02.25.01.5.11.74.02.05.04.09.06.13,0,0,0,0,0,0,0,0,0,0,0,0,0,.01.01.02.02.03,0,0,0,.01,0,.02.01.02.02.03.03.04,0,0,0,0,0,0,0,.01.02.02.03.03,0,0,0,0,.01.01,0,0,.02.01.02.02,0,0,0,0,.01.01,0,0,.02.01.02.02,0,0,0,0,.01,0,.01,0,.02.01.03.02,0,0,0,0,0,0,.01,0,.03.01.04.02,0,0,0,0,0,0,.01,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,0,0h0c1.15,0,2.22-4.28,2.53-7.52,0-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.03,0-.06.01-.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.14,50.5c4.33,0,7.86,3.52,7.86,7.85s-3.52,7.86-7.86,7.86-7.85-3.52-7.85-7.86,3.52-7.85,7.85-7.85m0-1c-4.89,0-8.85,3.96-8.85,8.85s3.96,8.86,8.85,8.86,8.86-3.96,8.86-8.86-3.96-8.85-8.86-8.85h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent31);
export default __webpack_public_path__ + "static/media/event3-1.605dbde420ce8c239810ff6627212c7e.svg";
export { ForwardRef as ReactComponent };